import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 1280px)', width: '90vw' }]

export default function LianaDesktop({
  classNames,
  image,
  imageAlt,
  height = 844,
}: {
  classNames: string
  image: string
  imageAlt?: string
  height?: number
}): React.ReactElement {
  return (
    <ResponsiveImage
      alt={imageAlt}
      fit="cover"
      height={height}
      imageClassName={`absolute z-0 max-w-none ${classNames}`}
      loading="eager"
      mediaQuery={mediaQuery}
      srcKey={image}
      width={1080}
    />
  )
}
